/**
 * Shared validation utilities
 */

/**
 * Validate if a string is a valid URL
 */
export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

/**
 * Validate if a string is a valid email
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Validate if a string is a valid phone number
 * Supports formats like: +1 (555) 123-4567, 555-123-4567, +44 20 7946 0958
 */
export const isValidPhone = (phone: string): boolean => {
  // Remove all whitespace and common separators for digit counting
  const digitsOnly = phone.replace(/[\s\-\(\)\.\+]/g, '')
  // Must have at least 7 digits (local) and no more than 15 (international max)
  if (digitsOnly.length < 7 || digitsOnly.length > 15) return false
  // Must only contain digits after stripping separators
  if (!/^\d+$/.test(digitsOnly)) return false
  // Allow formats with optional + prefix and common separators
  const phoneRegex = /^\+?[\d\s\-\(\)\.]+$/
  return phoneRegex.test(phone)
}
